<template>
    <v-expansion-panel-header
        :expand-icon="!$vuetify.breakpoint.lgAndUp ? '' : null"
    >
        <template v-slot:actions v-if="!$vuetify.breakpoint.lgAndUp">
            <v-icon class="expand_icon"> $expand</v-icon>
        </template>
        <div class="d-flex px-5 py-6">
            <div class="card_logo">
                <img
                    :width="(socialNetwork.slug === 'instagram' ? '58px' : '58px')"
                    :height="(socialNetwork.slug === 'instagram' ? '58px' : '58px')"
                    :src="socialNetwork.logo"
                    :alt="socialNetwork.type"
                />
            </div>
            <div class="mt-2 ml-4">
<!--                <router-link :to="'/subscriptions'" class="next_payment mb-1">Next payment</router-link>-->
<!--                <p class="payment_date mb-1" v-html="(socialNetwork.next_pay ? socialNetwork.next_pay : 'n/a')"></p>-->
            </div>
            <div class="d-flex d-lg-none"></div>
        </div>
        <div
            class="mt-6 mt-lg-0 ml-lg-n10 d-none d-lg-flex align-center flex-lg-row"
        >
            <div class="text-center d-lg-flex">
                <div class="mt-2 mr-2">
                    <img
                        width="25px"
                        height="25px"
                        src="../assets/followers.svg"
                        alt="followers"
                    />
                </div>

                <div class="text-center text-lg-left">
                    <p class="followers_sum my-1">{{ scores.followers }}</p>
                    <p class="followers_title mb-0">Followers</p>
                </div>
            </div>
            <v-spacer class="d-lg-none"></v-spacer>
            <v-btn
                class="buy_btn d-block d-lg-none mt-4 ml-lg-6"
                width="110px"
                height="50px"
                outlined
                rounded
                color="#2C4370"
            >
                Buy
            </v-btn>
        </div>
        <div
            class="mt-6 mt-lg-0 ml-lg-n10 d-none d-lg-flex align-center flex-lg-row"
        >
            <div class="text-center d-lg-flex">
                <div class="mt-2 mr-2">
                    <img
                        width="25px"
                        height="25px"
                        src="../assets/message.svg"
                        alt="comments"
                    />
                </div>

                <div class="text-center text-lg-left">
                    <p class="followers_sum my-1">{{ scores.comments }}</p>
                    <p class="followers_title mb-0">Comments</p>
                </div>
            </div>
        </div>
        <v-spacer class="d-lg-none"></v-spacer>
        <div
            class="mt-6 mt-lg-0 ml-lg-n10 d-none d-lg-flex align-center flex-lg-row"
        >
            <div class="text-center d-lg-flex">
                <div class="mt-1 mr-2">
                    <img
                        width="25px"
                        height="25px"
                        src="../assets/like.svg"
                        alt="likes"
                    />
                </div>

                <div class="text-lg-left">
                    <p class="followers_sum my-1">{{ scores.likes }}</p>
                    <p class="followers_title mb-0">Likes</p>
                </div>
            </div>
            <v-spacer></v-spacer>
            <div class="py-6 mt-9 mt-lg-0 mb-4 mb-lg-0 mb-lt-0 d-flex justify-center">
                <v-btn
                    class="buy_btn mb-3 mb-lg-0 mr-lg-5"
                    width="189px"
                    height="60px"
                    outlined
                    rounded
                    color="#2C4370"
                >
                    Change plan
                </v-btn>
            </div>
        </div>
    </v-expansion-panel-header>
</template>

<script>

export default {
    name: "InstagramCardHeader",
    props: ["socialNetwork", "scores"],
    data() {
        return {};
    }
};
</script>
